var ElementType, _, appendChild, cloneNode, commonAncestor, createElement, createTextNode, domutils, firstChild, getElementById, getElementsByTagName, getInnerHTML, getOuterHTML, htmlparser, insertChildBefore, lastChild, lastDescendantNodeOrSelf, nextNode, nextSibling, nodeNextBranch, normalizeDOM, parents, parseDOM, prettyDOM, previousNode, previousSibling, removeElement, shortestPath, stopEventPropagation;

ElementType = require('domelementtype');

htmlparser = require('htmlparser2');

domutils = require('domutils');

_ = require('underscore-plus');


/*
Create
 */

parseDOM = function(string, options) {
  var handler, out, parser;
  if (!options) {
    options = {
      decodeEntities: true,
      lowerCaseTags: true,
      xmlMode: true
    };
  }
  out = null;
  handler = new htmlparser.DomHandler(function(error, parsedDOM) {
    if (error) {
      throw error;
    } else {
      return out = parsedDOM;
    }
  });
  parser = new htmlparser.Parser(handler, options);
  parser.write(string);
  parser.done();
  return out;
};

createElement = function(tagName, attribs) {
  if (attribs == null) {
    attribs = {};
  }
  return {
    type: ElementType.Tag,
    name: tagName.toLowerCase(),
    attribs: attribs,
    children: []
  };
};

createTextNode = function(text) {
  return {
    type: ElementType.Text,
    data: text
  };
};

cloneNode = function(node) {
  var clone, each, i, len, ref;
  clone = Object.assign({}, node);
  if (clone.children) {
    clone.children = [];
    ref = node.children;
    for (i = 0, len = ref.length; i < len; i++) {
      each = ref[i];
      domutils.appendChild(clone, cloneNode(each));
    }
  }
  return clone;
};


/*
Manipulate
 */

appendChild = function(parent, child) {
  return domutils.appendChild(parent, child);
};

insertChildBefore = function(parent, child, sibling) {
  return domutils.appendChild(parent, child);
};

removeElement = function(element) {
  return domutils.removeElement(element);
};

firstChild = function(parent) {
  var ref;
  return (ref = parent.children) != null ? ref[0] : void 0;
};

lastChild = function(parent) {
  var children;
  if (children = parent.children) {
    return children[children.length - 1];
  }
  return null;
};

parents = function(node) {
  var nodes;
  nodes = [node];
  while (node = node.parent) {
    nodes.unshift(node);
  }
  return nodes;
};

nextSibling = function(node) {
  return node.next;
};

previousSibling = function(node) {
  return node.prev;
};

shortestPath = function(node1, node2) {
  var commonDepth, parents1, parents2;
  if (node1 === node2) {
    return [node1];
  } else {
    parents1 = parents(node1);
    parents2 = parents(node2);
    commonDepth = 0;
    while (parents1[commonDepth] === parents2[commonDepth]) {
      commonDepth++;
    }
    parents1.splice(0, commonDepth - 1);
    parents2.splice(0, commonDepth);
    return parents1.concat(parents2);
  }
};

commonAncestor = function(node1, node2) {
  var parents1, parents2;
  if (node1 === node2) {
    return [node1];
  } else {
    parents1 = parents(node1);
    parents2 = parents(node2);
    while (parents1[depth] === parents2[depth]) {
      depth++;
    }
    return parents1[depth - 1];
  }
};

previousNode = function(node) {
  var prev;
  if (prev = previousSibling(node)) {
    return lastDescendantNodeOrSelf(prev);
  } else {
    return node.parent || null;
  }
};

nextNode = function(node) {
  var first, next, parent;
  if (first = firstChild(node)) {
    return first;
  } else {
    next = nextSibling(node);
    if (next) {
      return next;
    } else {
      parent = node.parent;
      while (parent) {
        next = nextSibling(parent);
        if (next) {
          return next;
        }
        parent = parent.parent;
      }
      return null;
    }
  }
};

nodeNextBranch = function(node) {
  var next, p;
  if (next = nextSibling(node)) {
    return next;
  } else {
    p = node.parent;
    while (p) {
      if (next = nextSibling(p)) {
        return next;
      }
      p = p.parent;
    }
    return null;
  }
};

lastDescendantNodeOrSelf = function(node) {
  var each, last;
  last = lastChild(node);
  each = node;
  while (last) {
    each = last;
    last = lastChild(each);
  }
  return each;
};

getElementById = function(id, element, recurse) {
  return domutils.getElementById(id, element);
};

getElementsByTagName = function(name, element, recurse, limit) {
  return domutils.getElementsByTagName(name, element, recurse, limit);
};

normalizeDOM = function(element, skip) {
  var each, i, len, ref, ref1, results;
  if (skip == null) {
    skip = {};
  }
  if (skip[element.name]) {
    return;
  }
  if (((ref = element.children) != null ? ref.length : void 0) > 0) {
    ref1 = element.children.slice();
    results = [];
    for (i = 0, len = ref1.length; i < len; i++) {
      each = ref1[i];
      if (each.type === ElementType.Text) {
        results.push(removeElement(each));
      } else {
        results.push(normalizeDOM(each, skip));
      }
    }
    return results;
  }
};

prettyDOM = function(element, skip, trimEmpty, indent) {
  var childIndent, each, i, len, ref;
  if (skip == null) {
    skip = {};
  }
  if (trimEmpty == null) {
    trimEmpty = {};
  }
  if (indent == null) {
    indent = '\n';
  }
  if (skip[element.name]) {
    return;
  }
  if (element.children.length > 0) {
    childIndent = indent + '  ';
    ref = element.children.slice();
    for (i = 0, len = ref.length; i < len; i++) {
      each = ref[i];
      domutils.prepend(each, createTextNode(childIndent));
      prettyDOM(each, skip, trimEmpty, childIndent);
    }
    return domutils.append(lastChild(element), createTextNode(indent));
  }
};

getInnerHTML = function(node, options) {
  return domutils.getInnerHTML(node, options);
};

getOuterHTML = function(node, options) {
  return domutils.getOuterHTML(node, options);
};

stopEventPropagation = function(commandListeners) {
  var commandListener, commandName, fn, newCommandListeners;
  newCommandListeners = {};
  fn = function(commandListener) {
    return newCommandListeners[commandName] = function(event) {
      event.stopPropagation();
      return commandListener.call(this, event);
    };
  };
  for (commandName in commandListeners) {
    commandListener = commandListeners[commandName];
    fn(commandListener);
  }
  return newCommandListeners;
};

module.exports = {
  parseDOM: parseDOM,
  createElement: createElement,
  createTextNode: createTextNode,
  cloneNode: cloneNode,
  appendChild: appendChild,
  firstChild: firstChild,
  lastChild: lastChild,
  parents: parents,
  shortestPath: shortestPath,
  commonAncestor: commonAncestor,
  previousNode: previousNode,
  nextNode: nextNode,
  nodeNextBranch: nodeNextBranch,
  lastDescendantNodeOrSelf: lastDescendantNodeOrSelf,
  getElementById: getElementById,
  getElementsByTagName: getElementsByTagName,
  normalizeDOM: normalizeDOM,
  prettyDOM: prettyDOM,
  getInnerHTML: getInnerHTML,
  getOuterHTML: getOuterHTML,
  stopEventPropagation: stopEventPropagation
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dom.js
 ** module id = 71
 ** module chunks = 0
 **/